/**
 * SFrame215 — Complete Tax Filings (debts-taxes dt-5)
 */

import { useParams } from 'react-router-dom';
import SettlementStepPage from '../settlement/SettlementStepPage';
import TaxFilingIdentificationHelper from '../settlement/TaxFilingIdentificationHelper';
import { SETTLEMENT_PHASE_CONFIGS } from '../../utils/settlementFlowConfig';

const step = SETTLEMENT_PHASE_CONFIGS['debts-taxes'].steps.find((s) => s.id === 'dt-5')!;

export default function SFrame215() {
  const { estateId } = useParams<{ estateId: string }>();

  return (
    <SettlementStepPage step={step} phase="debts-taxes" overviewRoute="/sframe-198">
      {estateId ? (
        <TaxFilingIdentificationHelper
          estateId={estateId}
          variant="calendar"
          title="Deadlines, extensions, and confirmations"
        />
      ) : null}
    </SettlementStepPage>
  );
}
